'use strict';

module.exports = {
    VIRTUAL_HOST: 'virtualhost',
    PATH: 'path'
};